import React, { useEffect, useState } from 'react';
import styles from './AdminSection.module.css';
import {
  BaseStyles,
  Flex,
  Box,
  Button,
  Heading,
  Card,
  Field,
  Input,
} from 'rimble-ui';
import { PAYMENT_OPTION, TOKEN_TYPE } from '../../constants';

function AdminSection(props) {
  return (
    <BaseStyles>
      <Flex className={styles.root}>
        <Box>
          <Card>
            <Flex className={styles.adminBtns}>
              <Box>
                <Heading as='h2'>Admin: </Heading>
              </Box>
              <Box className={styles.btnGroup}>
                <Button
                  size='small'
                  mainColor='primary'
                  className={styles.adminBtn}
                  onClick={async () => {
                    await props.adminWithdrawETH();
                  }}
                >
                  Withdraw ETH
                </Button>
                <Button
                  size='small'
                  mainColor='primary'
                  className={styles.adminBtn}
                  onClick={async () => {
                    await props.adminWithdrawZUT();
                  }}
                >
                  Withdraw ZUT
                </Button>
              </Box>
            </Flex>
            <Flex className={styles.smartContractBalance}>
              <Box>
                <Heading as='h4'>
                  Smart Contract has {props.eth} ETH and {props.zut} ZUT
                </Heading>
              </Box>
            </Flex>
            <Flex className={styles.smartContractEthFees}>
              <Box>
                <Field label='Set Eth Fees'>
                    <Input
                      type='text'
                      required={true}
                      placeholder='ex: 0.05'
                      value={props.ethFeesInputVal}
                      onChange={(event) => {
                        props.onChangeEthFeesInputVal(event.target.value);
                      }}
                    />
                    <Button
                      size='small'
                      className={styles.setFees}
                      onClick={() => {
                        props.setNFTMultisendETHFees();
                      }}
                    >
                      Set
                    </Button>
                </Field>
              </Box>
            </Flex>
            <Flex className={styles.smartContractZutFees}>
              <Box>
                <Field label='Set Zut Fees'>
                  <Input
                    type='text'
                    required={true}
                    placeholder='ex: 0.1'
                    value={props.zutFeesInputVal}
                    onChange={(event) => {
                      props.onChangeZutFeesInputVal(event.target.value);
                    }}
                  />
                  <Button
                    size='small'
                    className={styles.setFees}
                    onClick={() => {
                      props.setNFTMultisendZUTFees();
                    }}
                  >
                    Set
                  </Button>
                </Field>
              </Box>
            </Flex>
          </Card>
        </Box>
      </Flex>
    </BaseStyles>
  );
}

export default AdminSection;
